module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/omelnickiy-a315780-avatar-309a8c9343602f4b37c2893a994364dd.jpg";